import { RequestBuilder } from "../requestBuilder";
import {
  AutoTopUpResponseSchema,
  CheckoutSessionResponseSchema,
  CreateCheckoutInputSchema,
  CreatePortalInputSchema,
  FundableOrganizationsResponseSchema,
  PortalSessionResponseSchema,
  StartAutoTopUpCardInputSchema,
  SubscriptionResponseSchema,
  UpdateAutoTopUpInputSchema,
  UpgradeInputSchema,
  UpgradePreviewParamsSchema,
  UpgradePreviewResponseSchema,
  UpgradeResponseSchema,
} from "./billingClient.types";

// The organization being funded rides the tenancy header, which is not
// necessarily the one the buyer belongs to, so every call site names it.

// POST /orgs/billing/checkout - open a payment session
export const CreateCheckoutRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/checkout",
  bodySchema: CreateCheckoutInputSchema,
  responseSchema: CheckoutSessionResponseSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// POST /orgs/billing/portal - open the provider's self-service portal
export const CreatePortalSessionRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/portal",
  bodySchema: CreatePortalInputSchema,
  responseSchema: PortalSessionResponseSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// GET /orgs/billing/subscription - the organization's current subscription
export const GetSubscriptionRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/subscription",
  responseSchema: SubscriptionResponseSchema,
}).withIncludeOrganizationId();

// GET /orgs/billing/upgrade-preview - what a self-serve upgrade would charge and grant
export const UpgradePreviewRequestConfig = new RequestBuilder({
  paramsSchema: UpgradePreviewParamsSchema,
  path: () => "/orgs/billing/upgrade-preview",
  responseSchema: UpgradePreviewResponseSchema,
})
  .withQueryParams((params) => ({ target: params.target }))
  .withIncludeOrganizationId();

// POST /orgs/billing/upgrade - change plan and charge the prorated amount on the saved card
export const UpgradeRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/upgrade",
  bodySchema: UpgradeInputSchema,
  responseSchema: UpgradeResponseSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// GET /orgs/billing/auto-topup - owner-only
export const GetAutoTopUpRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/auto-topup",
  responseSchema: AutoTopUpResponseSchema,
})
  .withContentType(undefined)
  .withIncludeOrganizationId();

// PUT /orgs/billing/auto-topup - full replace of the settings
export const UpdateAutoTopUpRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/auto-topup",
  bodySchema: UpdateAutoTopUpInputSchema,
  responseSchema: AutoTopUpResponseSchema,
})
  .withMethod("PUT")
  .withIncludeOrganizationId();

// POST /orgs/billing/auto-topup/card - open a session that saves the caller's
// card and makes them the payer
export const StartAutoTopUpCardRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/auto-topup/card",
  bodySchema: StartAutoTopUpCardInputSchema,
  responseSchema: CheckoutSessionResponseSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// GET /billing/fundable-organizations - the purchase picker's rows.
// Authenticated only: it answers across every organization the caller reaches,
// so it cannot be scoped to one of them.
export const FundableOrganizationsRequestConfig = new RequestBuilder({
  path: () => "/billing/fundable-organizations",
  responseSchema: FundableOrganizationsResponseSchema,
});
